<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- Six square teeth on a solid body, the hub knocked out (r3.5). -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1"
      stroke-linejoin="round"
      fill-rule="evenodd"
      d="M10 4.772L10.6 1.5L13.4 1.5L14 4.772A7.5 7.5 0 0 1 17.26 6.654L20.393 5.538L21.793 7.962L19.26 10.118A7.5 7.5 0 0 1 19.26 13.882L21.793 16.038L20.393 18.462L17.26 17.346A7.5 7.5 0 0 1 14 19.228L13.4 22.5L10.6 22.5L10 19.228A7.5 7.5 0 0 1 6.74 17.346L3.607 18.462L2.207 16.038L4.74 13.882A7.5 7.5 0 0 1 4.74 10.118L2.207 7.962L3.607 5.538L6.74 6.654A7.5 7.5 0 0 1 10 4.772ZM16 12a4 4 0 1 0 -8 0a4 4 0 1 0 8 0Z"
    />
  </svg>
</template>
